// extracted by mini-css-extract-plugin
export default {"title":"SMIgFF","container":"PxKcnr","graphics":"zo1rQW"};